import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import { StyledTableCell, StyledTableRow } from "../../reusableComponent/Reusables";
import styles from '../../../styles.module.css';
import customerMasterService from "../../../services/masters/customerMaster.Service";

const CylinderInwardDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const row = location.state || {};
  const [customermap, setCustomer] = useState([]);
  const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);

  useEffect(() => {
    async function fetchCustomerData() {
      try {
        const customerData = await customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" });
        setCustomer(Object.fromEntries(customerData.map(c => [c.cust_id, c.cust_name])));
      } catch (error) {
        console.error("Error fetching customer data:", error);
      }
    }

    fetchCustomerData();
    setSelectedCylinderDetails(safeParse(row.table_details));
  }, [row]);

  const safeParse = (jsonString) => {
    if (jsonString && typeof jsonString === "string") {
      try {
        return JSON.parse(jsonString);
      } catch (e) {
        console.error("Error parsing JSON", e);
        return [];
      }
    }
    return [];
  };

  const dateConversion = (date) => {
    if (!date) return "";
    const today = new Date(date);
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  return (
    <Box sx={{ padding: '16px', margin: '0 auto', maxWidth: '90vw' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography sx={{ fontSize: "22px", fontWeight: "bold" }}>
          Inward No: {row.entry_no || "N/A"}
        </Typography>
        <IconButton
          onClick={() => navigate('/storeEntries/cylinder-inward-list')}
          sx={{ color: 'red' }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Grid container sx={{ borderBottom: "1px solid #616161" }}>
        <Grid item xs={12}>
          <Box sx={{ padding: "6px", textAlign: "left" }}>
            <Grid container>
              <Grid item xs={3}>
                <Box>
                  <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>From Location</Typography>
                  <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>Party Name</Typography>
                  <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>Inward No</Typography>
                  <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>Inward Date</Typography>
                  <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>Driver Name</Typography>
                  <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>Vehicle No</Typography>
                  <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>Challan No</Typography>
                </Box>
              </Grid>
              <Grid item xs={0.5}>
                <Box sx={{ textAlign: "center" }}>
                  <Typography sx={{ fontSize: "18px" }}>:</Typography>
                  <Typography sx={{ fontSize: "18px" }}>:</Typography>
                  <Typography sx={{ fontSize: "18px" }}>:</Typography>
                  <Typography sx={{ fontSize: "18px" }}>:</Typography>
                  <Typography sx={{ fontSize: "18px" }}>:</Typography>
                  <Typography sx={{ fontSize: "18px" }}>:</Typography>
                  <Typography sx={{ fontSize: "18px" }}>:</Typography>
                </Box>
              </Grid>
              <Grid item xs={8.5}>
                <Box>
                  <Typography sx={{ fontSize: "18px" }}>{row.from_location || "N/A"}</Typography>
                  <Typography sx={{ fontSize: "18px" }}>
                    {row.from_location === "customer"
                      ? row.cust_name
                      : row.from_depot_name || "N/A"}
                  </Typography>
                  <Typography sx={{ fontSize: "18px" }}>{row.entry_no || "N/A"}</Typography>
                  <Typography sx={{ fontSize: "18px" }}>{dateConversion(row.entry_date)}</Typography>
                  <Typography sx={{ fontSize: "18px" }}>{row.driver_name || "N/A"}</Typography>
                  <Typography sx={{ fontSize: "18px" }}>{row.vehicle_no || "N/A"}</Typography>
                  <Typography sx={{ fontSize: "18px" }}>{row.challan_no || "N/A"}</Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>

      <Box sx={{ height: "20px" }} />

      <TableContainer sx={{ minWidth: 50 }}>
        <Table size="small" style={{ borderCollapse: "collapse" }}>
          <TableHead>
            <StyledTableRow>
              <StyledTableCell align="left" className={`${styles.print_table_head}`} width="10%">
                Sr No
              </StyledTableCell>
              <StyledTableCell align="left" className={`${styles.print_table_head}`} width="30%">
                Cylinder No
              </StyledTableCell>
              <StyledTableCell align="center" className={`${styles.print_table_head}`} width="30%">
                Tag No
              </StyledTableCell>
              <StyledTableCell align="center" className={`${styles.print_table_head}`} width="30%">
                Owner
              </StyledTableCell>
              <StyledTableCell align="center" className={`${styles.print_table_head}`} width="30%">
                Status
              </StyledTableCell>
              <StyledTableCell align="center" className={`${styles.print_table_head}`} width="30%">
                UOM
              </StyledTableCell>
              <StyledTableCell align="center" className={`${styles.print_table_head}`} width="30%">
                Check
              </StyledTableCell>
            </StyledTableRow>
          </TableHead>

          <TableBody>
            {selectedCylinderDetails.length > 0 ? (
              selectedCylinderDetails.map((row, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell align="left" className={`${styles.print_table_body_sec}`}>
                    {index + 1}
                  </StyledTableCell>
                  <StyledTableCell align="left" className={`${styles.print_table_body_sec}`}>
                    {row.cylinder_no || "N/A"}
                  </StyledTableCell>
                  <StyledTableCell align="center" className={`${styles.print_table_body_sec}`}>
                    {row.tag_no || "N/A"}
                  </StyledTableCell>
                  <StyledTableCell align="center" className={`${styles.print_table_body_sec}`}>
                    {row.owner === "TGPL"
                      ? "TGPL"
                      : row.customer_id
                      ? customermap[row.customer_id] || "Customer"
                      : "N/A"}
                  </StyledTableCell>
                  <StyledTableCell align="center" className={`${styles.print_table_body_sec}`}>
                    {row.status || "N/A"}
                  </StyledTableCell>
                  <StyledTableCell align="center" className={`${styles.print_table_body_sec}`}>
                    {row.uom || "N/A"}
                  </StyledTableCell>
                  <StyledTableCell align="center" className={styles.print_table_body_sec}>
                    {row.checked ? "True" : "False"}
                  </StyledTableCell>
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={7} align="center">
                  No cylinder details available
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CylinderInwardDetails;